module.exports = __webpack_public_path__ + "img/publication-2.9b0b245d.svg";